import React from 'react';

import composerNameToID  from '../helpers/composerNameToID';
import convertSpotifyWebLinkToNative from '../helpers/spotifyWebLinkToNative';

function MainComposer({composer, nativeLinks}) {
  const composerLinkList = composer.links.map((link, index) => {
    if (link.desc) {
      return <li key={`composer-${composer.name}-link-${index}`}>
        <a href={link.link}>{link.desc}</a>
      </li>
    }

    return null;
  });

  const composerWorkList = composer.works.map((work, index) => {
    const workLinks = work.links.map(() => {
      // TODO: make this into a STATEFUL component, that, if clicked on, opens up an in-place selection window for
        // TODO: Deezer
        // TODO: Spotify
        // TODO: Apple Music
      // TODO: this way... won't clutter the main screen with this selection!
      // if (workLink.desc === 'Deezer') {
      //   return <span>
      //     <a href={workLink.link}>
      //       <img className="musicIcon" alt="deezer icon" src="https://img.icons8.com/color/48/000000/deezer.png"/>
      //     </a>
      //   </span>
      // }
      // if (workLink.desc === 'Spotify') {
      //   return <span>
      //     <a href={workLink.link}>
      //     <img className="musicIcon" alt="spotify icon" src="https://img.icons8.com/color/48/000000/spotify--v1.png"/>
      //     </a>
      //   </span>
      // }
      // if (workLink.desc === 'Apple Music') {
      //   return <span>
      //     <a href={workLink.link}>
      //     <img className="musicIcon" alt="apple music icon" src="https://img.icons8.com/ios-glyphs/30/000000/apple-music.png"/>
      //     </a>
      //   </span>
      // }
      return null;
    })

    const favoriteMovements = work.favoriteMovements.map((fav, index) => {
      return <li key={`${composer.name}-favorite-${index}`}>{fav}</li>
    })

    const workTitle = (<span>
      {/* NOTE: THIS is the LINK on the "chronological (index)" page */}
      <a href={convertSpotifyWebLinkToNative(work.links[0].link, nativeLinks)}>{work.title}</a>
    </span>);

    return (
      <div className="workLine" key={`${composer.name}-work-${index}`}>
        <li className="workText">
          {
            work.favorite ?
              <span role="img" className="favoriteIcon" aria-label="favoriteIcon">⭐</span>
              : <span className="favoriteIcon"></span>
          }
          <div className="workName">
            {workTitle} (p. {work.premierDate}) {workLinks}
          </div>
        </li>
        <ul className="favoriteMovements">{favoriteMovements}</ul>
      </div>
    )
  });

  return (
    <div className="composer" key={`composer-${composer.name}`}>
      <h2
        className="composerName"
        id={composerNameToID(composer.name)}
      >
        {composer.name}<br/>
        <span className="composerDetails">
          {composer.yearBorn} - {composer.yearDied} ({composer.nationality})
        </span>
      </h2>
      <ul>{composerLinkList}</ul>
      Works
      <ul>{composerWorkList}</ul>
    </div>
  );
}

export default MainComposer;
